import create from 'zustand'
import { devtools } from 'zustand/middleware'


export const authInitialData = {
  actionButtonShowed: false,
}


const useGlobalStore = create(devtools(
  set => ({
    ...authInitialData,
    showActionButton: value => {
      set({
        actionButtonShowed: value,
      })
    },
  })
))

export default useGlobalStore
